import { Model } from 'dva'
import { Entity } from './types'
import { EntitiesService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const Entities: Model = {
  namespace: 'entities',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let entities = yield select((state: any) => state.entities.list)
        if (!(entities.length > 0 && useCache)) {
          entities = yield call(EntitiesService.entitiesList, {})
          yield put({ type: 'modifyList', payload: entities })
        }
        onSuccess(entities)
      } catch (err: any) {
        FailureHandler('Error fetching entities', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let entity = yield select((state: any) =>
          state.entities.list.find((entity: Entity) => entity.id === id)
        )
        if (!entity) {
          entity = yield call(EntitiesService.entitiesRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: entity })
        onSuccess(entity)
      } catch (err) {
        FailureHandler('Could not find the entity!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(EntitiesService.entitiesCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a entity', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(EntitiesService.entitiesPartialUpdate, {
          id: id,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a entity', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(EntitiesService.entitiesDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a entity', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: Entity) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: Entity) => !action.payload.map((p: Entity) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: Entity) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetSLUEntities(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default Entities
